module.exports = __webpack_public_path__ + "static/media/bike.d58cdf5d.png";